import React, { ReactNode }                         from "react";
import { connect }                                  from "react-redux";
import ChangeStaffPassword                          from "../../../application/usecase/staff/ChangeStaffPassword";
import GetStaff                                     from "../../../application/usecase/staff/GetStaff";
import MenuType                                     from "../../../domain/menu/MenuType";
import Staff                                        from "../../../domain/staff/Staff";
import StaffRepository                              from "../../../domain/staff/StaffRepository";
import { ResKaState }                               from "../../../index";
import StaffDataSource                              from "../../../infrastructure/datasource/staff/StaffDataSource";
import Breadcrumbs                                  from "../../components/common/Breadcrunmbs";
import BackHistoryButton                            from "../../components/common/BuckHistoryButton";
import BottomSection                                from "../../components/common/layout/BottomSection";
import TopSection                                   from "../../components/common/layout/TopSection";
import PasswordChangeButton                         from "../../components/common/PasswordChangeButton";
import StaffDeleteButton                            from "../../components/staff/StaffDeleteButton";
import StaffEditForm                                from "../../components/staff/StaffEditForm";
import StaffUpdateButton                            from "../../components/staff/StaffUpdateButton";
import ResKaBaseContainer, { BaseProps, BaseState } from "../ResKaBaseContainer";

interface Props extends BaseProps {
  getStaff: GetStaff;
  changeStaffPassword: ChangeStaffPassword;
  staff: Staff;
  staffRepository: StaffRepository;
}

class StaffEditContainer extends ResKaBaseContainer<Props, BaseState> {
  constructor(props: Props) {
    const state = {
      menuType: MenuType.SETTING,
      headerTitle: "スタッフ編集",
    };

    super(props, state);
  }

  protected componentDidMountInternal(): void {
    this.props.getStaff.execute(this.props.staff.id);
  }

  protected renderInternal(): ReactNode {
    return (
      <>
        <TopSection>
          <Breadcrumbs breadcrumbs={
            [
              {
                title: "設定",
                path: "/setting"
              },
              {
                title: "スタッフ一覧",
                path: "/staffs"
              },
              {
                title: "スタッフ編集",
                path: "/staff/edit"
              },
            ]
          }/>
        </TopSection>

        <TopSection>
          <StaffUpdateButton/>
          <StaffDeleteButton staff={ this.props.staff }/>
          <BackHistoryButton path="/staffs"/>
        </TopSection>

        <TopSection>
          <PasswordChangeButton
            onClick={ (currentPassword, newPassword, confirmPassword, callback) => this.props.changeStaffPassword.execute(this.props.staff.id, currentPassword, newPassword, confirmPassword, callback) }
          />
        </TopSection>

        <StaffEditForm/>

        <BottomSection>
          <StaffUpdateButton/>
          <BackHistoryButton path="/staffs"/>
        </BottomSection>
      </>
    );
  }

}

const mapStateToProps = (state: ResKaState) => ({
  fetchStatus: state.fetchStatus,
  staff: state.staff,
});

const mapDispatchToProps = (dispatch) => ({
  getStaff: new GetStaff(dispatch),
  changeStaffPassword: new ChangeStaffPassword(dispatch),
  staffRepository: new StaffDataSource(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(StaffEditContainer);
